module.exports = __webpack_public_path__ + "img/hada.3e839009.jpg";